let notificationsEnabled = false;
let audioCtx = null;

export const PushNav = { chatId: null };

export function ensureNotificationsEnabled() {
  if (typeof Notification === 'undefined') return false;
  if (Notification.permission === 'granted') {
    notificationsEnabled = true;
    return true;
  }
  return false;
}

export function requestNotificationPermission() {
  if (typeof Notification === 'undefined') return Promise.resolve('denied');
  if (Notification.permission === 'granted') {
    notificationsEnabled = true;
    return Promise.resolve('granted');
  }
  return Notification.requestPermission().then((perm) => {
    notificationsEnabled = perm === 'granted';
    return perm;
  });
}

export function playBlaBlaSound() {
  try {
    if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const frequencies = [523.25, 659.25, 783.99, 1046.5];
    frequencies.forEach((freq, i) => {
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();
      osc.connect(gain);
      gain.connect(audioCtx.destination);
      osc.frequency.value = freq;
      osc.type = 'sine';
      gain.gain.setValueAtTime(0.15, audioCtx.currentTime + i * 0.12);
      gain.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + i * 0.12 + 0.3);
      osc.start(audioCtx.currentTime + i * 0.12);
      osc.stop(audioCtx.currentTime + i * 0.12 + 0.3);
    });
  } catch (e) {}
}

export function showBrowserNotification(title, body, chatId) {
  if (!notificationsEnabled) return;
  try {
    const n = new Notification(title, {
      body: body?.substring(0, 200) || '',
      icon: '/tryndi_icon.jpeg',
      tag: 'trandi-message',
      renotify: true,
      requireInteraction: false,
    });
    n.onclick = () => {
      window.focus();
      PushNav.chatId = chatId || null;
    };
    setTimeout(() => n.close(), 5000);
  } catch (e) {}
}
